/**
 * Formato della pagina del PDF caricato su un volantino
 * @module flyers/utils/pdfPageSize
 */

const MM_PER_INCH = 25.4;

const positive = (value) => {
    const n = Number(value);
    return Number.isFinite(n) && n > 0 ? n : null;
};

/**
 * Larghezza e altezza in mm scelte al caricamento del PDF. Sui volantini che non le hanno
 * salvate si ricavano dalle pagine rasterizzate e dal loro DPI (stesso ripiego dell'export
 * PDF lato server). Se manca anche quello restituisce null: meglio non mostrare nulla che
 * un formato inventato.
 * @param {object|null} preprocessConfig - `flyer.preprocessConfig`, oppure `pdfPageSize`
 *   delle liste volantini (stessi campi)
 * @returns {{widthMm: number, heightMm: number}|null}
 */
export const resolvePdfPageSizeMm = (preprocessConfig) => {
    const cfg = preprocessConfig || {};
    const widthMm = positive(cfg.pdfWidthMm);
    const heightMm = positive(cfg.pdfHeightMm);
    if (widthMm && heightMm) return { widthMm, heightMm };

    const rasterW = positive(cfg.rasterPageWidth);
    const rasterH = positive(cfg.rasterPageHeight);
    const dpi = positive(cfg.rasterDpi);
    if (rasterW && rasterH && dpi) {
        return { widthMm: rasterW * MM_PER_INCH / dpi, heightMm: rasterH * MM_PER_INCH / dpi };
    }
    return null;
};

/**
 * Testo del formato, es. "210 × 297 mm" (al massimo un decimale, senza zeri inutili).
 * @param {object|null} preprocessConfig - `flyer.preprocessConfig`
 * @returns {string|null}
 */
export const formatPdfPageSize = (preprocessConfig) => {
    const size = resolvePdfPageSizeMm(preprocessConfig);
    if (!size) return null;
    const fmt = (mm) => String(Math.round(mm * 10) / 10).replace(".", ",");
    return `${fmt(size.widthMm)} × ${fmt(size.heightMm)} mm`;
};
